import {format} from "date-fns";

export default function transformRequest(data:unknown) {
  if(data == null || typeof data !== "object") {
    return data
  }
  visitObject(data, function (key:string, val:unknown, holder:unknown) {
    if(val != null && val instanceof Date){
      // @ts-expect-error It works in practice
      holder[key] = format(val,"yyyy-MM-dd'T'HH:mm:ss")
    }
  })
  return data
}

// @ts-expect-error It works in practice
const visitObject = (obj:unknown, fn:unknown) => Object.entries(obj).forEach(([k, v]) => {
  // @ts-expect-error It works in practice
  return ((typeof v === 'object' && !(v instanceof Date)  && v !== null) ? visitObject(v, fn) : fn(k, v, obj))
});